import {Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {EntityFormContainer} from "@digidom/entity";
import {Deal} from "../../../models/deal";
import {DealsService} from "../../../store/entity/entity-services/deals.service";
import {StagesService} from "../../../store/entity/entity-services/stages.service";
import {DealFormService} from "../../../services/deal/deal-form/deal-form.service";
import {Stage} from '../../../models/stage';
import {EMPTY, Observable} from "rxjs";
import {selectEntity} from "@digidom/common";
import {filter, first, map, mergeMap} from "rxjs/operators";
import {isKnownCRMType, Pipeline, PipelinesService} from "@digidom/crm";
import {ObjectDescriptor} from "../../../../../../entity/src/lib/models/object-descriptor";
import {EntityServices} from "@ngrx/data";
import {
  AssociationsTransferService
} from "../../../services/association/associations-transfer/associations-transfer.service";

@Component({
  selector: 'dd-deal-form',
  templateUrl: './deal-form.component.html',
  styleUrls: ['./deal-form.component.scss'],
  providers: [DealFormService]
})
export class DealFormComponent extends EntityFormContainer<Deal> implements OnInit {

  @Input()
  personId: string | undefined;

  @Input()
  organizationId: string | undefined;

  @Input()
  sourceObject?: ObjectDescriptor;

  stage$: Observable<Stage | undefined> | undefined;

  pipelines$?: Observable<Pipeline[]>;

  constructor(public override formService: DealFormService,
              public override entityService: DealsService,
              public stagesService: StagesService,
              public pipelinesService: PipelinesService,
              public entityServices: EntityServices,
              public associationsTransferService: AssociationsTransferService
  ) {
    super(formService, entityService);
  }

  override ngOnInit() {

    super.ngOnInit();

    this.pipelinesService.getAll();

  }

  override ngOnChanges(changes: SimpleChanges): void {

    super.ngOnChanges(changes);

    if (this.personId) {
      this.patchForm({person_id: this.personId});
    }

    if (this.organizationId) {
      this.patchForm({organization_id: this.organizationId});
    }

    if (this.sourceObject) {

      this.patchForm({
        source_object: {
          object_type: this.sourceObject.object_type.toLowerCase(),
          id: this.sourceObject.id
        }
      });

      let sourceEntityService;
      if (isKnownCRMType(this.sourceObject.object_type)) {
        sourceEntityService = this.entityServices.getEntityCollectionService(this.sourceObject.object_type);
      } else {
        sourceEntityService = this.entityServices.getEntityCollectionService('CustomObject');
      }

      sourceEntityService.getByKey(this.sourceObject.id).pipe(first()).subscribe(sourceEntity => {

        if (sourceEntity.properties) {

          this.patchForm({
            properties: sourceEntity.properties
          });

          if (!this.sourceObject) {
            throw new Error('Missing source object');
          }

          this.associationsTransferService.createTransfer(this.sourceObject, 'Deal').pipe(first()).subscribe(
            associations => {
              if (associations?.length) {
                this.patchForm({
                  associations
                });
              }
            }
          );

        }
      });

    }

    if (this.model$) {
      this.stage$ = this.model$.pipe(
        filter(deal => !!deal),
        mergeMap(deal => {
          if (!deal){
            return EMPTY;
          }

          return selectEntity(this.stagesService, deal.pipeline.stage_id)
        })
      );
    }

    this.pipelines$ = this.pipelinesService.entities$.pipe(map(pipelines => {
      return pipelines.filter(pipeline => pipeline.object_type === 'deal');
    }));
  }
}
